import type { CSSProperties } from 'vue'

export const urlPattern = /[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]/

export const LOGO_DEFAULT_WIDTH = 180
export const LOGO_MIN_WIDTH = 40
export const LOGO_MAX_WIDTH = 400

export const headerLogoStyle = (logoWidth?: number): CSSProperties =>
  logoWidth
    ? { width: `${logoWidth}px`, maxWidth: '100%', height: 'auto' }
    : { maxWidth: `${LOGO_DEFAULT_WIDTH}px`, maxHeight: '80px', objectFit: 'contain' }
